module.exports = __webpack_public_path__ + "static/img/live_weixin_zh.09709eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live_weixin_zh.png
// module id = gOG4
// module chunks = 0